import { useEffect, useState } from "react";
import { shouldReduceMotion } from "../utils/performance";

/**
 * Drives MotionConfig + scroll perf: reduced motion on touch / narrow viewports.
 */
export default function useMotionProfile() {
  const [reduceMotion, setReduceMotion] = useState(shouldReduceMotion);

  useEffect(() => {
    const queries = [
      window.matchMedia("(prefers-reduced-motion: reduce)"),
      window.matchMedia("(hover: none) and (pointer: coarse)"),
      window.matchMedia("(max-width: 1023px)"),
    ];

    const sync = () => setReduceMotion(shouldReduceMotion());
    sync();

    queries.forEach((mq) => mq.addEventListener("change", sync));
    return () => queries.forEach((mq) => mq.removeEventListener("change", sync));
  }, []);

  return { reduceMotion };
}
